import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b235b89e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return _withDirectives((_openBlock(), _createBlock(_component_Button, {
    id: "cp-button",
    onClick: _ctx.onClick,
    icon: "pi pi-copy",
    class: "p-button-rounded p-button-text"
  }, null, 8, ["onClick"])), [
    [
      _directive_tooltip,
      _ctx.message,
      void 0,
      { top: true }
    ],
    [
      _directive_tooltip,
      _ctx.message,
      void 0,
      {
        top: true,
        hover: true
      }
    ]
  ])
})